import type { WithingsAuthConfig } from "../types/domain";

import { core } from "@tauri-apps/api";

import { debugHealth } from "@/domains/logging/utils/debugLog";

/**
 * Speichert die Withings-Konfiguration im Tauri Secure Storage
 *
 * @param config
 *
 */
export async function saveWithingsConfig(config: WithingsAuthConfig): Promise<void> {
  try {
    // Sending config

    await core.invoke("set_withings_config", { config });
  } catch (error) {
    // NOTE: set_withings_config fehlgeschlagen
    debugHealth("error", "withingsConfigService", "saveWithingsConfig failed", {
      error: error instanceof Error ? error.message : String(error),
    });
    throw new Error("Withings-Konfiguration konnte nicht gespeichert werden.");
  }
}

/**
 * Lädt die aktuelle Withings-Konfiguration aus dem Tauri Secure Storage
 *
 * @returns {Promise<null | WithingsAuthConfig>} Loaded config or null
 *
 */
export async function loadWithingsConfig(): Promise<null | WithingsAuthConfig> {
  try {
    const config = await core.invoke<WithingsAuthConfig>("get_withings_config");
    // Reason: core.invoke return type is inferred as WithingsAuthConfig, but runtime may be undefined

    return config ?? null;
  } catch (error) {
    // NOTE: get_withings_config fehlgeschlagen
    debugHealth("error", "withingsConfigService", "loadWithingsConfig failed", {
      error: error instanceof Error ? error.message : String(error),
    });
    throw new Error("Withings-Konfiguration konnte nicht geladen werden.");
  }
}

/**
 * Löscht die Withings-Konfiguration aus dem Tauri Secure Storage
 */
export async function clearWithingsConfig(): Promise<void> {
  try {
    const parameters = { provider: "withings" };
    // Calling clear_tokens with params

    await core.invoke("clear_tokens", { params: parameters });
  } catch (error) {
    // NOTE: clear_tokens fehlgeschlagen
    debugHealth("error", "withingsConfigService", "clearWithingsConfig failed", {
      error: error instanceof Error ? error.message : String(error),
    });
    throw new Error("Withings-Konfiguration konnte nicht gelöscht werden.");
  }
}
